// src/types/kyc.types.ts
export enum ActivityType {
  NONE = 'NONE',
  ADULT_ENTERTAINMENT = 'ADULT_ENTERTAINMENT',
  DRUGS = 'DRUGS',
  FIREARMS = 'FIREARMS',
  GAMBLING = 'GAMBLING',
  MARIJUANA = 'MARIJUANA',
  TUMBLING = 'TUMBLING'
}

export enum VendorsCounterparties {
  SELF = 'SELF',
  MERCHANTS_SUPPLIERS = 'MERCHANTS_SUPPLIERS',
  CUSTOMERS = 'CUSTOMERS',
  EMPLOYEES = 'EMPLOYEES',
  CONTRACTORS = 'CONTRACTORS',
  FRIENDS = 'FRIENDS',
  FAMILY = 'FAMILY'
}

// Alias para compatibilidad
export const engageInActivities = ActivityType;

export interface KycInfoData {
  funds_send_receive_jurisdictions: string[];
  engage_in_activities: ActivityType[];
  vendors_and_counterparties: VendorsCounterparties[];
}

export type ValidationErrors = Partial<Record<keyof KycInfoData, string>>;